import { Dialog, DialogActions, DialogContent, LinearProgress } from '@mui/material';
import React, { useState } from 'react'

import Webcam from "react-webcam";
import { AutoAwesome, CameraAlt } from '@mui/icons-material';

import { useAlert } from '../../../context/AlertContext';
import { Add, PhotoCamera } from '@mui/icons-material';
import api from '../../../api/api'
import LabelValueJsonEditor from './LabelValueJsonEditor';
import Tesseract from 'tesseract.js';



function CameraImage({uploadCameraImage}) {

    const [facingMode,setFacingMode] = useState("user")
    const swicthCamera = () =>{
        if(facingMode == "user"){
            setFacingMode("environment")
        }
        if(facingMode == "environment"){
            setFacingMode("user")
        }
    }

    const videoConstraints = {
        
        facingMode: facingMode,
    };

    
    const [dialogStatus,setDialogStatus] = useState(false);

    return (
    <>
        <button type="button" className="btn btn-dark btn-lg mt-2" onClick={()=>setDialogStatus(true)}><CameraAlt/> Open Camera</button>
        <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                fullScreen={true}
                aria-describedby="alert-dialog-slide-description"
        >
            <DialogContent style={{padding:0}}>
            <div className="row">
                <div className="col-md-12 text-center">
                    {dialogStatus == true &&
                        <Webcam
                            audio={false}
                            
                            screenshotFormat="image/jpeg"
                           
                            videoConstraints={videoConstraints}
                        >
                            {({ getScreenshot }) => (
                                <><br/>
                                <button
                                    className="btn btn-primary m-2"
                                    onClick={() => {
                                        let imageSrc = getScreenshot();
                                        uploadCameraImage(imageSrc);
                                        setDialogStatus(false);
                                    }}
                                
                                >
                                    Capture photo
                                </button>
                                <button type="button" onClick={swicthCamera} className="btn btn-dark m-2">Switch Camera</button>
                                <button type="button" onClick={()=>setDialogStatus(false)} className="btn btn-outline-primary m-2">Cancel</button>
                                </>
                            )}
                        </Webcam>
                    }
                </div>
            </div>
            </DialogContent>
        </Dialog>

        
    

    </>
  )
}



function DocumentImage({documentId,callBack,activityId}) {
    const {AppAlert } = useAlert()
    const [dialogStatus,setDialogStatus] = useState("");
    const [savingInProgress,setSavingStatus] = useState("");
    
    
    const [selectedFile,setSelectedFile] = useState(null)
    const [fileTitle,setFileTitle] = useState("")
    const [remark,setRemark] = useState("");
    const [jsonData,setJsonData] = useState([]);
    
    const [uploadInProgress, setUploadProgress] = useState(null);

    const handleClose = () =>{
        setSelectedFile(null)
        setDialogStatus(false)
    }

    const isImage = (file) =>{
        if(file.type.match('image.*')){
            return true;
        }
        return false;
    }
    
    const selectFile = (e) =>{
        if(!isImage(e.target.files[0])){
            AppAlert("Invalid File Type","error");
            return false;
        }
        setSelectedFile(e.target.files[0])
        
    }

    const uploadToServer = (formData) =>{ 
        api.post("/fms/document/image",formData,{
            onUploadProgress: (progressEvent) => { 
                const { loaded, total } = progressEvent;
                let percent = Math.floor((loaded * 100) / total);
                //console.log(percent);
                setUploadProgress(percent)
            },
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        }).then( (res)=>{
            AppAlert(res.data.msg)
            callBack();
        }).catch( (error) => {
            AppAlert(error.msg,"error")
        }).finally(()=>{
            setUploadProgress(null)
            handleClose();
        })
      }

    const onSubmit = () => {
        let formData = new FormData();
        
        formData.append('documentId',documentId);
        formData.append('tmpFile', selectedFile);
        formData.append('fileTitle', fileTitle);
        formData.append('remark', remark);
        
        if(activityId !== undefined){
            formData.append('activityId',activityId);
        }

        let _jsonData = jsonData.filter(json=> json.label!=="" || json.value!=="" )
        formData.append('jsonData', JSON.stringify(_jsonData));
        
        uploadToServer(formData);
    }

    /*****   Camera Work In Progress */
    const  DataURIToBlob = (dataURI) => {
        const splitDataURI = dataURI.split(',')
        const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
        const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

        const ia = new Uint8Array(byteString.length)
        for (let i = 0; i < byteString.length; i++)
            ia[i] = byteString.charCodeAt(i)

        return new Blob([ia], { type: mimeString })
    }
    const selectCameraImage = (image) => {
        setSelectedFile(DataURIToBlob(image))
    }

    const readTextFromImage = async () =>{
        const result = await Tesseract.recognize(selectedFile);
        setRemark(result.data.text);
    }

    return (
        <>
            {activityId !== undefined && <div className='btn btn-primary me-2' onClick={()=>setDialogStatus(true)} ><PhotoCamera /><Add/></div>}
            {activityId === undefined && <div className='btn btn-primary me-2' onClick={()=>setDialogStatus(true)} ><PhotoCamera /></div> }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
            >
                <DialogContent>
                    {selectedFile !== null && 
                        <div className='row'>
                            <div className='col-md-6'>
                                <div className='text-center'>
                                    <img className='img-fluid' style={{maxHeight:400}}  alt="preview image" src={URL.createObjectURL(selectedFile)} />
                                </div>
                            </div>
                            <div className='col-md-6 mt-2'>
                                <div className="form-floating mb-3 ">
                                    <input type="text" className="form-control"  placeholder=""  value={fileTitle} onChange={(e)=>setFileTitle(e.target.value)} />
                                    <label >Image Title *</label>
                                </div>

                                <div className="mb-3 ">
                                    <label >Remark * </label>
                                    <button className='btn btn-outline-success float-end mb-2' onClick={()=>readTextFromImage()} ><AutoAwesome/> Read Text From Image</button>
                                    <textarea  className="form-control"  placeholder=""  value={remark} onChange={(e)=>setRemark(e.target.value)} style={{height:100}} />
                                </div>

                                
                                <div>
                                    <LabelValueJsonEditor jsonData={jsonData} setJsonData={setJsonData} />
                                </div>
                            </div>
                        </div>
                    }
                    {selectedFile == null &&
                        <div className="d-flex justify-content-center">
                            <div>
                                <CameraImage uploadCameraImage={selectCameraImage} />
                            </div>
                            <div>
                                <div className="form-group mt-2">
                                    <input type="file"
                                        className='d-none'
                                        onChange={ (e)=>{ selectFile(e) } } 
                                        accept="image/png, image/gif, image/jpeg"
                                        id="uploadDocumentImage" 
                                    />
                                    <label for="uploadDocumentImage" className='btn btn-primary ms-2 btn-lg'>Upload Image</label>
                                </div>
                            </div>
                        </div>
                    }
                </DialogContent>
                <DialogActions>
                    {selectedFile!==null &&
                        <div className='row'>
                            <div className='col-md-12'>
                                {savingInProgress && <LinearProgress />}
                                {!savingInProgress &&
                                    <>
                                        <button className='btn btn-outline-primary me-2' onClick={handleClose} >Cancel</button>
                                        <button className='btn btn-primary' disabled={remark===""} onClick={onSubmit}>Upload</button>
                                    </>
                                }
                            </div>
                        </div>
                    }
                </DialogActions>
            </Dialog>
        </>
    )
}

export default DocumentImage